import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MatSnackBar } from "@angular/material/snack-bar";

import { VehiclesHandlerService } from "../../api-handlers/vehicles-handler.service";

@Component({
  selector: "edit-model-modal",
  templateUrl: "./edit-model-modal.component.html",
})
export class EditModelModalComponent implements OnInit {
  modelId?: string;
  name?: string;
  closed_at?: string;
  selectedBrandName?: string;
  brandsData?: Array<any>;
  modelsData?: Array<any>;

  activeChecked: boolean;
  didUserEdit = false;
  errorMessage = "";
  isLoading = false;
  modelSubmitted = false;

  originalName: string;

  brandsFilteredOptions: Observable<any>;
  updateModelForm: FormGroup;

  get getModelFormControls() {
    return this.updateModelForm.controls;
  }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private vehicleService: VehiclesHandlerService
  ) {}

  ngOnInit() {
    this.activeChecked = this.closed_at === "0";
    this.originalName = this.name;

    this.updateModelForm = this.formBuilder.group({
      nome: [
        this.name,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
        ],
      ],
      marca: [this.selectedBrandName, [Validators.required]],
    });

    this.brandsFilteredOptions = this.updateModelForm.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value.marca || ""))
    );
  }

  private _filter(value: string) {
    const filterValue = value.toLowerCase();

    return this.brandsData.filter((option) =>
      option.vehicleModels.vbr_name.toLowerCase().includes(filterValue)
    );
  }

  async onUpdateModelSubmit() {
    this.modelSubmitted = true;
    this.isLoading = true;

    try {
      const name = this.getModelFormControls.nome.value.trim();
      const selectedBrand = this.getModelFormControls.marca.value;

      const doesNameExist = this.modelsData.find(
        (model) =>
          name === model?.vehicleModels.vmd_name && name !== this.originalName
      );

      const foundBrand = this.brandsData.find(
        (b) => b.vehicleModels.vbr_name === selectedBrand
      );

      if (doesNameExist) {
        throw new Error("Modello già esiste");
      }

      if (!foundBrand) {
        throw new Error("Marca non esiste");
      }

      const updateModelBody = {
        vmd_id: this.modelId,
        vmd_brand_id: foundBrand.vehicleModels.vbr_id,
        vmd_name: name,
        vmd_closed: this.activeChecked ? 0 : 1,
      };

      await this.vehicleService.adminUpdateModel(updateModelBody);

      this.errorMessage = "";
      this.updateModelForm.reset();
      this.bsModalRef.hide();
      this.snackBar.open(`Modello "${this.name}" modificato`, undefined, {
        duration: 3000,
      });
    } catch (error) {
      this.errorMessage = error.message;
    } finally {
      this.isLoading = false;
      this.modelSubmitted = false;
    }
  }
}
